/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  homeLoanService,
  quickToolService,
  dateTimeService,
  FeeAndChargeType,
  aboutUsDetailsPdfService,
  signaturesPdfService,
  INSTANCE
) => ({
  createHomeLoanFeesAndCharges: ({
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    loan,
    isView
  }) => {
    const deferred = $q.defer();
    const currentOrganization = $rootScope.CurrentOrganization;
    const currentCurrency = $rootScope.CurrentCurrency();
    const currentTimeZone = $rootScope.CurrentTimeZone();
    const now = moment.utc().tz(currentTimeZone).format('X');
    const date = dateTimeService.getFormattedDate(now);
    const availableFeeAndChargeTypes = FeeAndChargeType.available;

    const prepareFeeAndCharge = ({ feeAndCharge, count }) => {
      const content = [];
      content.push(
        helperPdfService.createSubHeader({
          title: `${feeAndCharge?.feeAndChargeType?.name.toUpperCase()} #${count}`
        })
      );
      content.push({
        table: {
          widths: ['40%', '30%', '30%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Services to be provided\n',
                    style: 'label'
                  },
                  {
                    text: feeAndCharge?.name || '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Maximum amount payable (inc. GST)\n', style: 'label' },
                  {
                    text: helperService
                      .isNumber(feeAndCharge?.amount || 0, true)
                      .formatWithCurrency(currentCurrency, 2),
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  {
                    text: 'When is the fee payable?\n',
                    style: 'label'
                  },
                  {
                    text: feeAndCharge?.feePayable || '-',
                    style: 'value'
                  }
                ]
              }
            ]
          ]
        },
        layout: 'noBorders'
      });
      return content;
    };

    const prepareFeesAndCharges = ({ feesAndCharges }) => {
      const content = [];
      content.push({
        text: '',
        margin: [0, 20, 0, 0]
      });
      content.push(
        helperPdfService.createHeader({
          title: 'FEES AND CHARGES'
        })
      );
      let provisionOfCreditAssistance = 0;
      let costsIncurredByUs = 0;
      let paymentsMadeOnYourBehalf = 0;
      const len = feesAndCharges?.length || 0;
      for (let i = 0; i < len; i += 1) {
        const feeAndCharge = feesAndCharges[i];
        if (feeAndCharge?.feeAndChargeType?.id === availableFeeAndChargeTypes[0].id) {
          provisionOfCreditAssistance += 1;
          content.push(
            prepareFeeAndCharge({
              feeAndCharge,
              count: provisionOfCreditAssistance
            })
          );
        }
        if (feeAndCharge?.feeAndChargeType?.id === availableFeeAndChargeTypes[1].id) {
          costsIncurredByUs += 1;
          content.push(
            prepareFeeAndCharge({
              feeAndCharge,
              count: costsIncurredByUs
            })
          );
        }
        if (feeAndCharge?.feeAndChargeType?.id === availableFeeAndChargeTypes[2].id) {
          paymentsMadeOnYourBehalf += 1;
          content.push(
            prepareFeeAndCharge({
              feeAndCharge,
              count: paymentsMadeOnYourBehalf
            })
          );
        }
      }
      content.push(
        helperPdfService.createSubHeader({
          title: 'TOTAL FEES AND CHARGES'
        })
      );
      content.push({
        table: {
          widths: ['40%', '30%', '30%'],
          body: [
            [
              '',
              {
                text: [
                  { text: 'Total\n', style: 'label' },
                  {
                    text: _.reduce(
                      feesAndCharges,
                      (sum, n) => _.add(sum, helperService.isNumber(n?.amount, true)),
                      0
                    ).formatWithCurrency(currentCurrency, 2),
                    style: 'value'
                  }
                ]
              },
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });
      return content;
    };

    const orgLogo = currentOrganization?.organization?.logo
      ? currentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          currentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],
        content: [
          {
            table: {
              widths: [240, '*'],
              headerRows: 1,
              body: [
                [
                  {
                    width: 180,
                    height: 30,
                    image: res.data,
                    margin: [5, 3, 0, 3],
                    style: 'tableHeader'
                  },
                  {
                    fillColor: '#eeeeee',
                    text: `Prepared on: ${date}`,
                    style: 'prepared'
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'CREDIT QUOTE'
          }),
          aboutUsDetailsPdfService.prepareAboutUsDetails({
            ticketOwner,
            showCreditLicenceDetails: true
          }),
          prepareFeesAndCharges({
            feesAndCharges: loan?.compliance?.feesAndCharges || []
          }),
          signaturesPdfService.prepareSignaturesDetails({
            contacts,
            contactLabels,
            ticket,
            ticketOwner,
            authorisationText:
              'By signing the below, you agree to the terms set out in the above schedule and to pay the amount specified. After you have signed this document, we will provide you with a copy for your records.',
            showIntroducer: false
          })
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 0]
          },
          subHeader: {
            fontSize: 11,
            margin: [0, 0, 0, 0]
          },
          subSubHeader: {
            fontSize: 10,
            margin: [0, 2, 0, 0]
          },
          subSubSubHeader: {
            fontSize: 10,
            margin: [5, 0, 5, 0]
          },
          prepared: {
            fontSize: 10,
            alignment: 'right',
            margin: [0, 12, 5, 0]
          },
          marginTop: {
            margin: [0, 7, 0, 0]
          },
          marginBottom: {
            margin: [0, 0, 7, 0]
          },
          tableFontSize: {
            fontSize: 10
          },
          tableHeader: {
            fillColor: '#eee'
          },
          tableCellMargin: {
            margin: [4, 2, 4, 2]
          },
          tableMarginTop: {
            margin: [0, 10, 0, 0]
          },
          tableCellMarginTop: {
            margin: [0, 2, 0, 0]
          },
          tableCellMarginLeftTopBottom: {
            margin: [4, 2, 0, 2]
          },
          tableCellMarginRightTopBottom: {
            margin: [0, 2, 4, 2]
          },
          tableCellMarginTopBottom: {
            margin: [0, 2, 0, 2]
          },
          tableCellLeftAlign: {
            alignment: 'left'
          },
          tableCellRightAlign: {
            alignment: 'right'
          },
          tableCellCenterAlign: {
            alignment: 'center'
          },
          label: { fontSize: 8, color: '#777' },
          value: { fontSize: 10 },
          valueXS: { fontSize: 8 },
          valueXL: { fontSize: 12 },
          lists: { fontSize: 10 },
          noColor: { color: '#fff' }
        }
      };
      pdfMake.tableLayouts = {
        defaultLayout: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 1 : 0.5;
          },
          vLineWidth() {
            return 0.5;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        header: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 2;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#000' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        subHeader: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 0.5;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#999' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 2;
          },
          paddingBottom() {
            return 2;
          }
        },
        noBorders: {
          hLineWidth() {
            return 0;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor() {
            return 0;
          },
          paddingLeft() {
            return 5;
          },
          paddingRight() {
            return 5;
          },
          paddingTop() {
            return 3;
          },
          paddingBottom() {
            return 3;
          }
        },
        noBordersNoPadding: {
          hLineWidth() {
            return 0;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor() {
            return 0;
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        }
      };
      const fileName = `${moment.utc().year()}${
        moment.utc().month() + 1
      }${moment.utc().date()} Credit quote.pdf`;
      if (!_.isEmpty(docDefinition)) {
        if (isView) {
          helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
            deferred.resolve();
          });
        } else {
          helperPdfService
            .viewOrSavePdf({
              ticket,
              docDefinition,
              fileName,
              isView: false
            })
            .then(() => {
              deferred.resolve();
            });
        }
      }
    });
    return deferred.promise;
  }
});
